var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "email__section" }, [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body py-2 my-25" }, [
          _vm.errorMessage
            ? _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.successMessage
            ? _c(
                "div",
                {
                  staticClass: "alert alert-success",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.successMessage) + "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-6 mb-1" }, [
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "account-old-password" }
                },
                [_vm._v("Current E-mail address")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__email" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.oldEmail,
                      expression: "oldEmail"
                    }
                  ],
                  staticClass: "form-control input__email",
                  attrs: {
                    type: "email",
                    disabled: true,
                    placeholder: "Enter current password"
                  },
                  domProps: { value: _vm.oldEmail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.oldEmail = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(1)
              ]),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "account-old-password" }
                },
                [_vm._v("New E-mail address")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__email" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newEmail,
                      expression: "newEmail"
                    }
                  ],
                  staticClass: "form-control input__email",
                  attrs: {
                    type: "email",
                    placeholder: "Enter current password"
                  },
                  domProps: { value: _vm.newEmail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newEmail = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "account-old-password" }
                },
                [_vm._v("\n              password")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__email" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control input__password",
                  attrs: {
                    type: "password",
                    placeholder: "Enter current password"
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cursor__pointer",
                    on: { click: _vm.showHide }
                  },
                  [
                    _c("i", {
                      staticClass: "password_i fa fa-eye-slash",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-4 div__save" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn__save",
                    attrs: { type: "button" },
                    on: { click: _vm.save }
                  },
                  [
                    _vm._v(
                      "\n                Save Email Address\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header border-bottom" }, [
      _c("h4", { staticClass: "card-title" }, [
        _vm._v("Change your account's email address")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cursor__pointer" }, [
      _c("i", {
        staticClass: "fa fa-envelope",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cursor__pointer" }, [
      _c("i", {
        staticClass: "fa fa-envelope",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba52f2a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba52f2a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user_profile/info/email.vue
// module id = null
// module chunks = 